// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    apiHost: 'https://kering.dev.cp-bc.com/api/v1.0',
    wsUrl: 'http://kering.dev.cp-bc.com',
    title: 'Surge: kering',
    organization: 'kering',
    type: 'eyedes', // legacy
    types: ['eyedes', 'cmpman', 'galvman', 'catalog'], // For multirole support
    // types: ['eyedes'], // For multirole support
    authType: 'azure',
    adAuthority: 'https://login.microsoftonline.com/7bc76c63-2ee4-46a6-b9a9-d680e49760d7',
    adClientId: 'a4f6e052-588a-4c01-aba4-f6d395535c64',
    faro: {
        url: 'https://collector-host:12345/collect',
        apiKey: 'secret',
        app: {
            name: 'frontend',
            version: '1.0.0'
        }
    }
}
